import Blue from "~/core";

new Blue({
  name: "Accordion",
  selector: ".accordion",
  setup(accordion) {
    const items = [...accordion.querySelectorAll('.accordion__item')];
    const relations = [];
  
    items.forEach(container => {
      let trigger = container.querySelector('.accordion__trigger');
      let content = container.querySelector('.accordion__content');
      let config = {
        container,
        trigger,
        content,
        relations,
      };
      relations.push(new this.$toggle(config));
    });

    // Optionally open the first item on load (widget "Start with First Item Open").
    if (accordion.hasAttribute("data-start-first-open") && relations.length) {
      relations[0].toggle();
    }
  },
});
